<div class="business-comp-guide">
    <div class="business-comp-guide-header font-class-one">
        <span><b>Add Client Projects</b></span>
        <a class="close-business-comp-guide" (click)="closeConfimationBox()">
            <i class="fas fa-times" style="color:white;"></i>
        </a>
        <p class="margin-two"> </p>
    </div>

    <div class="business-comp-guide-content-section font-class margin-class-top">
        <label class="font-b"> Business component: </label> {{selectedBusinessCompName}}
    </div>

    <div class="business-comp-guide-content-section font-class font-b">
        Client Projects
    </div>
    <div class="business-comp-guide-content-section font-class">
        <ng-multiselect-dropdown style="margin-top: 0 !important;"
            [placeholder]="'Select projects'"
            [settings]="dropdownSettings"
            [data]="unassignedProjectList"
            [(ngModel)]="selectedProjects"
            [ngModelOptions]="{standalone: true}"
            (onSelect)="onProjectSelect($event)"
            (onDeSelect)="onProjectDeSelect($event)"
            (onSelectAll)="onProjectSelectAll($event)"
            (onDeSelectAll)="onProjectDeSelectAll($event)"
            class="full-width">
        </ng-multiselect-dropdown>
    </div>
    <div class="business-comp-guide-content-section " style="flex-direction:column">
        <button type='button' class="btn font-class-two btn-success" (click)="addExistingProjectToBusinessComp(projectIdList)" [disabled]="projectIdList.length === 0">
            Add
        </button>
        <a (click)="closeConfimationBox()" class="btn-back">Cancel</a>
    </div>

</div>
